export default ({ app }) => {
  app.router.afterEach((to) => {
    if (window && window.dataLayer) {
      window.dataLayer.push({
        event: 'page_view',
        page_path: to.fullPath,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  });
}
